module.exports = __webpack_public_path__ + "static/img/waistDrum.b45ac02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/waistDrum.png
// module id = cgMy
// module chunks = 26